// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__16E4X","col":"styles_col__NPrFm","fulfillmentStatus":"styles_fulfillmentStatus__3x9yt","emailCol":"styles_emailCol__3EgNv"};